module.exports = __webpack_public_path__ + "img/google-play-badge.8cf712c7.png";